import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <main className="pt-40 pb-32 min-h-screen max-w-3xl mx-auto px-6 text-center" data-testid="not-found-page">
      <Seo title="Page not found | Ember & Steel Studio" description="That page doesn't exist. Browse the shop, services or request a quote." path="/404" noindex />
      <p className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#C87455]">404</p>
      <h1 className="font-serif-display text-4xl sm:text-5xl text-white mt-6">Nothing engraved here.</h1>
      <p className="text-zinc-400 mt-4">The page you're looking for has moved or never existed.</p>
      <div className="flex flex-wrap justify-center gap-3 mt-10">
        <Link to="/shop" data-testid="nf-shop-link" className="bg-[#C87455] text-black hover:bg-[#A65B3E] transition-colors px-6 py-3 font-mono-tech text-[10px] uppercase tracking-[0.2em]">Shop</Link>
        <Link to="/services" data-testid="nf-services-link" className="border border-zinc-700 text-zinc-200 hover:border-[#C87455] transition-colors px-6 py-3 font-mono-tech text-[10px] uppercase tracking-[0.2em]">Services</Link>
        <Link to="/quote" data-testid="nf-quote-link" className="border border-zinc-700 text-zinc-200 hover:border-[#C87455] transition-colors px-6 py-3 font-mono-tech text-[10px] uppercase tracking-[0.2em]">Request a quote</Link>
      </div>
    </main>
  );
}
